import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useMediaQuery } from 'react-responsive';
import { MdArrowLeft } from 'react-icons/md';



function Login() {
    const isXlOrLarger = useMediaQuery({ minWidth: 1280 });
    const [language, setLanguage] = useState(() => {
        const languageNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return languageNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [category, setCategory] = useState("Teacher")

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const logDetails = getLogDetails();
        if (logDetails) {
            // console.log("details found");
            sessionStorage.setItem("greetings", "true");
            const categorySaved = logDetails.category;
            if ((categorySaved).toUpperCase() === "TEACHER") {
                if (isXlOrLarger) {
                    navigate('/desktop/teacher/dashboard');
                } else {
                    navigate('/mobile/teacher/greeting');
                }
            } else if ((categorySaved).toUpperCase() === "STUDENT") {
                if (isXlOrLarger) {
                    navigate('/desktop/student/dashboard');
                } else {
                    navigate('/mobile/student/dashboard');
                }
            } else if ((categorySaved).toUpperCase() === "RESEARCHER") {
                if (isXlOrLarger) {
                    navigate('/mobile/researcher/dashboard');
                } else {
                    navigate('/mobile/researcher/dashboard');
                }
            } else if ((categorySaved).toUpperCase() === "TRANSLATOR") {
                if (isXlOrLarger) {
                    navigate('/desktop/translator/dashboard');
                } else {
                    navigate('/mobile/translator/greeting');
                }
            }
        } else {
            // console.log("details not found");
            const languageNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
            setLanguage(languageNow);
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem('language', languageNow);
        }
    }, [])

    const handleContinue = () => {

        if (category === "") {
            handleClickOpen();
            return;
        }

        localStorage.setItem('category', category);
        // console.log("category1",localStorage.getItem('category'));
        navigate('/loginpage');
    }

    const categoryOptions = [
        { key: "Teacher", label: t('t3') },
        { key: "Student", label: t('t4') },
        { key: "Translator", label: t('t5') },
        { key: "Researcher", label: t('t6') },
    ];

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-no-repeat bg-cover bg-opacity-[10] min-h-screen w-screen flex flex-col  md:items-center`}>
            <div className="fixed inset-0 bg-white/50 z-0"></div>
            <Menu as="div" className="absolute top-0 right-0 m-[10px] text-left items-right z-20">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className='relative z-10 h-full  w-full'>
                <div className='flex items-center justify-start cursor-pointer mt-[20px] xl:mt-[100px] 2xl:mt-[150px] xl:ml-[170px] 2xl:ml-[250px]'>
                   <MdArrowLeft className='text-[25px] md:text-[35px] lg:text-[33px] xl:text-[25px] 2xl:text-[22px]' />
                    <button className={`z-10 hover:underline font-bold ${i18n.language === "en" ? "text-[17px] md:text-[23px] lg:text-[23px] xl:text-[15px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[14px] md:text-[19px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[20px] xl:text-[13px] 2xl:text-[18px]")}`} onClick={() => {
                        navigate('/user/boarding');
                    }}>
                        {t('t455')}
                    </button>
                </div>
                <div className='pl-[30px] pr-[30px] flex flex-col justify-start items-center h-full w-full absolute top-[10vh] md:top-[13vh] xl:top-[14vh] 2xl:top-[17vh]  '>
                    <div className='md:w-[400px] lg:w-[500px] xl:w-[550px]  2xl:w-[500px] flex flex-col items-center justify-center'>
                        <img src="/images/logo.svg" className="h-[100px] md:h-[130px] xl:h-[120px] 2xl:h-[130px]" alt='logo' />
                        <p className={`text-[#1E2533] text-center font-[600] leading-[27px] xl:leading-[30px] ${i18n.language === "en" ? "text-[21px] md:text-[23px] lg:text-[27px] xl:text-[27px] 2xl:text-[28px]" : (i18n.language === "si" ? "text-[19px] md:text-[22px] lg:text-[19px] xl:text-[22px] 2xl:text-[18px]" : "text-[16px] md:text-[19px] lg:text-[17px] xl:text-[20px] 2xl:text-[18px]")} mt-[20px]`}>{t('t2_2')}</p>
                        <p className={`text-[#1E2533] text-center font-[400] leading-[16px] xl:leading-[18px] ${i18n.language === "en" ? "text-[13px] md:text-[13px] lg:text-[15px] xl:text-[14px] 2xl:text-[16px]" : (i18n.language === "si" ? "text-[10px] md:text-[11px] lg:text-[12px] xl:text-[11px] 2xl:text-[11px]" : "text-[10px] md:text-[11px] lg:text-[11px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{t('t474')}</p>
                        {categoryOptions.map(({ key, label }, index) => (
                            <button
                                key={key}
                                onClick={() => setCategory(key)}
                                className={`font-[600] ${index === 0 ? 'mt-[20px]' : 'mt-[10px]'} rounded-lg border-2 ${category === key ? 'border-[#EFAE03]' : 'border-transparent'} hover:border-[#EFAE03] bg-[#FEFBE8] text-[#CE8500] pt-[10px] pb-[10px] w-full lg:w-[350px] 2xl:w-[400px] hover:bg-[#FEFBE8]
                             ${i18n.language === "en" ? "text-[16px] md:text-[19px] xl:text-[17px] 2xl:text-[19px]" : (i18n.language === "si" ? "text-[14px] md:text-[15px] xl:text-[16px] 2xl:text-[18px]" : "text-[13px] md:text-[14px] xl:text-[15px] 2xl:text-[18px]")}
                            `}
                            >
                                {label}
                            </button>
                        ))}
                        <button onClick={handleContinue} className={`font-[600] text-white text-[18px] mt-[40px] rounded-lg pt-[10px] pb-[10px] w-full lg:w-[350px] 2xl:w-[400px] hover:bg-opacity-80 bg-[#EFAE03] `}>{t('t7')}</button>
                        <p className={`text-[#333333] ${i18n.language === "en" ? "text-[14px] md:text-[18px] xl:text-[15px] 2xl:text-[16px]" : (i18n.language === "si" ? "text-[12px] md:text-[14px] xl:text-[14px] 2xl:text-[14px]" : "text-[11px] md:text-[14px] xl:text-[12px] 2xl:text-[14px]")} text-center mt-[20px] mb-[20px]`}>{t('t8')} <span onClick={() => (navigate('/createnewaccount'))} className={`font-[700] text-[#333333] hover:cursor-pointer underline`}>{t('t9')}</span></p>
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="custom-dialog-title"
                            aria-describedby="custom-dialog-description"
                            className="backdrop-blur-sm"
                        >
                            <DialogTitle
                                id="custom-dialog-title"
                                className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                            >
                                ⚠️  {t('t48')}
                            </DialogTitle>
                            <DialogContent className="bg-gray-50">
                                <DialogContentText
                                    id="custom-dialog-description"
                                    className="text-gray-600 text-md mt-2"
                                >
                                    {t('t10')}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className="px-4 py-2">
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t13')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;